<template>
  <v-app-bar class="red" app dense dark absolute flat>
    <v-toolbar-title>ระบบการติดตามสถานะสิ่งของ Tracking EMS</v-toolbar-title>
    <v-spacer></v-spacer>
  </v-app-bar>
</template>

<script>
export default {
  name: "Navbar",
};
</script>

<style>
.red{
  background-color: #dd0000 !important;
}
</style>